<template>
  <div>
    <span v-for="(labelInfo, index) in sortedLabelList" :key="index" :class="['label', 'label-tag', 'mr-1', { 'label-empty': outlineStyle }]" :style="labelStyles(labelInfo)">
      <i class="fal fa-tag mr-1" v-if="labelInfo.isFixed"></i>
      <i class="fas fa-circle pr-1" v-if="!labelInfo.isFixed && outlineStyle" :style="{color: labelInfo.colour}"></i>
      {{labelInfo.name}}
    </span>
  </div>
</template>

<script>
import _ from 'lodash'
import colourMixin from '@/mixins/colour'

export default {
  name: 'LabelTags',
  mixins: [colourMixin],
  props: {
    labelList: Array,
    outlineStyle: Boolean
  },
  computed: {
    sortedLabelList() {
      if(!this.labelList)
        return []

      // Put fixed/system labels first
      var outputList = this.labelList.filter(labelInfo => labelInfo.isFixed)
      outputList = outputList.concat(this.labelList.filter(labelInfo => !labelInfo.isFixed))

      // Remove duplicates
      outputList = _.uniqBy(outputList, 'id')

      return outputList
    }
  },
  methods: {
    labelStyles(labelInfo) {
      var styles = {
      }

      if(!this.outlineStyle) {
        styles.color = this.textColourForBackground(labelInfo.colour)
        styles['background-color'] = labelInfo.colour
      }

      return styles
    }
  }
}
</script>